import React from 'react'
import Pg5 from '../../../myapp/services/add-money/Pg/Pg5'

function PG5Page() {
  return (
    <Pg5/>
  )
}

export default PG5Page